import {BaseService} from "./base";
import {isEmpty} from "../utils";

class ConsultationService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 会诊/转诊医院
   * @param.hosId
   * @returns {Promise<void>}
   */
  async groupHosList(hosId) {
    const {code, list = []} = await this.$http('smarthos.consult.group.hos.list', {hosId});
    return code === '0' ? list : [];
  }

  /**
   * 发起-医医会诊
   * @param form
   * @returns {Promise<void>}
   */
  async docIssue(form) {
    const {code, obj = {}} = await this.$http('smarthos.consult.group.doc.issue', form);
    return code === '0' ? obj : false;
  }

  /**
   * 发起- 医助医会诊
   * @param form
   * @returns {Promise<void>}
   */
  async assIssue(form) {
    const {code, obj = {}} = await this.$http('smarthos.consult.group.ass.issue', form);
    return code === '0' ? obj : false;
  }

  /**
   * 会诊列表
   * @param service
   * @param aspectUser
   * @param searchRange
   * @param consulterName
   * @param initHosId
   * @param acceptHosId
   * @param hopeHosId
   * @param startTime
   * @param endTime
   * @param pageNum
   * @param pageSize
   * @returns {Promise<*>}
   */
  async list(service, {aspectUser, searchRange, consulterName, initHosId, acceptHosId, hopeHosId, startTime, endTime, pageNum = 1, pageSize = 10}) {
    const {code, list = [], page = {}} = await this.$http(service, {
      aspectUser,
      searchRange,
      consulterName,
      initHosId,
      acceptHosId,
      hopeHosId,
      startTime,
      endTime,
      pageNum,
      pageSize
    });
    return code === '0' ? {list, page} : {list: [], page: {}};
  }

  /**
   * 通用列表
   * @param searchRange
   * @param aspectUser
   * @param consultGroupStatusList
   * @param startTime
   * @param endTime
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async groupList({searchRange, consultGroupStatusList, aspectUser, startTime, endTime, pageNum, pageSize}) {
    const {list = [], page = {}} = await this.$http('smarthos.consult.group.list', {
      consultGroupStatusList,
      searchRange,
      aspectUser,
      startTime,
      endTime,
      pageSize,
      pageNum
    });
    return {list, page};
  }

  /**
   * 会诊详情
   * @param consultId
   * @returns {Promise<{}>}
   */
  async detail(consultId) {
    const {code, obj} = await this.$http('smarthos.consult.group.detail', {consultId});
    return code === '0' ? obj : {};
  }

  /**
   * 取消申请
   * @param consultId
   * @param disagreeReason
   * @returns {Promise<void>}
   */
  async cancel({consultId, disagreeReason}) {
    const {code} = await this.$http('smarthos.consult.group.cancel', {
      consultId, disagreeReason
    });
    return code === '0'
  }

  /**
   * 拒绝申请
   * @param consultId
   * @param disagreeReason
   * @returns {Promise<void>}
   */
  async refuse({consultId, disagreeReason}) {
    const {code} = await this.$http('smarthos.consult.group.refuse', {
      consultId, disagreeReason
    });
    return code === '0'
  }

  /**
   * 要求补充资料
   * @param consultId
   * @param perfectReason
   * @returns {Promise<void>}
   */
  async askperfect({consultId, perfectReason}) {
    const {code} = await this.$http('smarthos.consult.group.askperfect', {consultId, perfectReason});
    return code === '0';
  }

  /**
   * 要求补充资料记录列表
   * @param consultId
   * @returns {Promise<Array>}
   */
  async perfectDetailList(consultId) {
    const {code, list = []} = await this.$http('smarthos.consult.perfectDetail.list', {consultId});
    return code === '0' ? list : [];
  }

  /**
   * 补充资料
   * @param consultId
   * @param consultContent
   * @param consultReason
   * @param beforeDiagnose
   * @param attaIdList
   * @param picList
   * @returns {Promise<void>}
   */
  async perfect({consultId, consultContent, consultReason, beforeDiagnose, attaIdList, picList}) {
    const {code} = await this.$http('smarthos.consult.group.perfect', {
      consultId, consultContent, consultReason, beforeDiagnose, attaIdList, picList
    });
    return code === '0';
  }

  /**
   * 处理会诊
   * @param consultId
   * @param auditStatus
   * @param readyStatus
   * @param acceptDocId
   * @param consultTime
   * @param perfectReason
   * @returns {Promise<boolean>}
   */
  async process({consultId, auditStatus = 1, readyStatus = 1, acceptDocId = undefined, consultTime = undefined, perfectReason = undefined, remark = ''}) {
    const {code} = await this.$http('smarthos.consult.group.ass.process', {
      consultId,
      auditStatus,
      readyStatus,
      acceptDocId,
      consultTime,
      perfectReason,
      remark
    });
    return code === '0';
  }

  /**
   * 完成会诊
   * @param consultId
   * @returns {Promise<void>}
   */
  async complete(consultId) {
    const {code} = await this.$http('smarthos.consult.group.complete', {consultId});
    return code === '0';
  }

  /**
   * 评价会诊
   * @param consultId
   * @param systemScore
   * @returns {Promise<boolean>}
   */
  async comment({consultId, systemScore}) {
    const {code} = await this.$http('smarthos.consult.group.comment', {consultId, systemScore});
    return code === '0';
  }


  /**
   * 建议，评价
   * @param consultId
   * @param consultAdvice
   * @param afterDiagnose
   * @param equalDiagnose
   * @param transfer
   * @param medicalScore
   * @param recordScore
   * @param pastHistoryScore
   * @param attaIdList
   * @returns {Promise<boolean>}
   */
  async advice({consultId, consultAdvice, afterDiagnose, equalDiagnose, transfer, medicalScore, recordScore, pastHistoryScore, attaIdList, referralSituation}) {
    const {code} = await this.$http('smarthos.consult.group.advice', {
      consultId,
      consultAdvice,
      afterDiagnose,
      equalDiagnose,
      transfer,
      medicalScore,
      recordScore,
      pastHistoryScore,
      attaIdList,
      referralSituation
    });
    return code === '0';
  }

  /**
   * 进入诊间
   * @param consultId
   * @returns {Promise<void>}
   */
  async intovideo(consultId) {
    const {code, obj} = await this.$http('smarthos.consult.group.intovideo', {
      consultId
    });
    return code === '0' ? obj : {};
  }

  /**
   * 回复
   * @param consultId
   * @param replyContent
   * @returns {Promise<void>}
   */
  async reply({consultId, replyContent, replyContentType}) {
    const {code} = await this.$http('smarthos.consult.group.reply', {consultId, replyContent, replyContentType});
    return code === '0';
  }

  /**
   * 消息列表
   * @param consultId
   * @param pageSize
   * @param pageNum
   * @returns {Promise<{page, list: Array}>}
   */
  async msglist({consultId, pageSize = 5000, pageNum = 1}) {
    const {list = [], page = {}} = await this.$http('smarthos.consult.message.list.page', {
      consultId,
      pageNum,
      pageSize
    }, 'post', false, false);
    return {list, page};
  }

  /**
   * 导出数据
   * @param countType
   * @param reportType
   * @param hosId
   * @param endTime
   * @param startTime
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async reportList({countType, consultGroupStatusList, hosId = undefined, endTime = undefined, startTime = undefined, pageNum = 1, pageSize = 10}) {
    const {code, list = [], page = {}} = await this.$http('smarthos.consult.group.report.list', {
      countType, consultGroupStatusList, hosId, endTime, startTime, pageNum, pageSize
    });
    return code === '0' ? {list, page} : {list: [], page: {}};
  }

  /**
   * 处理会诊列表数据
   * @param r
   */
  handlerListItem(r) {
    let ret = {
      consultStatusDescription: r.consultStatusDescription,
      ...r.consultGroup
    };
    ['Doc', 'Dept', 'Hos'].forEach(r => {
      if (isEmpty(ret[`accept${r}Name`])) {
        ret[`accept${r}Name`] = ret[`hope${r}Name`];
      }
    });
    if (ret.consultStatus === 'FINSH' || ret.consultStatus === 'NEEDCOMMENT') ret.consultStatusDescription = '已完成';
    // else if (ret.consultStatus === 'NEEDCOMMENT') ret.consultStatusDescription = '待评价';
    else if (ret.consultStatus === 'REFUSE') ret.consultStatusDescription = '已拒绝';
    else if (ret.consultStatusDescription === '已安排') ret.consultStatusDescription = '待会诊';
    else if (ret.consultStatusDescription === '待处理') ret.consultStatusDescription = '待审核';
    // else if (ret.consultStatus === 'GOING' && ret.auditStatus === false) {
    //   ret.consultStatusDescription = '资料缺失';
    // }
    return ret;
  }

  /**
   *  视频回放
   * */
  async getVideos(id) {
    const {code, obj = {}} = await this.$http('smarthos.consult.group.video', {
      consultId: id
    })
    return code == '0' ? obj : []
  }


}

export const consultationService = new ConsultationService();
